module.exports = __webpack_public_path__ + "static/img/0.a77df14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/0.png
// module id = fQT7
// module chunks = 2